<template>
  <tbody class="divide-y divide-white/5">
    <slot />
  </tbody>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
tbody {
  .tr {
    transition: background-color 0.2s ease-in-out;
    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }
}

@media (max-width: 600px) {
  tbody {
    display: block !important;
    width: 100%;
    overflow-x: auto;
  }
}
</style>
